import { useParams } from "react-router-dom";
import { projects } from "../../lib/projects.ts";
import React from "react";
import "./projectPage.css";
import { FiArrowLeft } from "react-icons/fi";

import { SampleProject1 } from "../../lib/sampleProject1.tsx";
import { SampleProject2 } from "../../lib/sampleProject2.tsx";
import { SampleProject3 } from "../../lib/sampleProject3.tsx";
const contentMap: Record<string, React.ComponentType> = {
    "sample-project-1": SampleProject1,
    "sample-project-2": SampleProject2,
    "sample-project-3": SampleProject3,
};

export default function ProjectPage() {
    const { slug } = useParams<{ slug: string }>();
    console.log("slug:", slug);

    const project = projects.find((p) => p.slug === slug);
    console.log("project:", project);

    const Content = slug ? contentMap[slug] : null;
    console.log("Content:", Content);

    if (!project || !Content) return <div>Project not found.</div>;

    console.log(slug);

    return (
        <div className="projectPage">
            <a className="projectPageBackArrow" href="/">
                <FiArrowLeft /> back
            </a>
            <h1>{project.title}</h1>
            <p className="projectPageDivider">⋆ ˚｡⋆୨୧˚⋆ ˚｡⋆˚｡⋆୨୧˚⋆ ˚｡⋆˚｡⋆୨୧˚⋆ ˚｡⋆˚｡⋆୨୧˚⋆ ˚｡⋆</p>
            <Content />
        </div>
    );
}
